<template>
  <span
    :aria-hidden="decorative"
    :aria-label="title"
    class="v-icon mdi theme--light text--text add-leak"
    role="img"
  >
    <svg
      :fill="fillColor"
      class="icon__svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <path
        d="m5.9289 21.607a2.0017 2.0017 0 0 1-2.0017-2.0017 2.0017 2.0017 0 0 1 2.0017-2.0017 2.0017 2.0017 0 0 1 2.0017 2.0017 2.0017 2.0017 0 0 1-2.0017 2.0017m0-7.6066a5.6049 5.6049 0 0 0-5.6049 5.6049c0 4.2037 5.6049 10.409 5.6049 10.409s5.6049-6.2054 5.6049-10.409a5.6049 5.6049 0 0 0-5.6049-5.6049z"
        stroke-width=".8007"
      />
      <path
        d="m27.39 5.8282a1.4695 1.4695 0 0 1-1.4695-1.4695 1.4695 1.4695 0 0 1 1.4695-1.4695 1.4695 1.4695 0 0 1 1.4695 1.4695 1.4695 1.4695 0 0 1-1.4695 1.4695m0-5.584a4.1145 4.1145 0 0 0-4.1145 4.1145c0 3.0859 4.1145 7.6412 4.1145 7.6412s4.1145-4.5554 4.1145-7.6412a4.1145 4.1145 0 0 0-4.1145-4.1145z"
        stroke-width=".58779"
      />
      <path
        d="m5 31h22c5 0 5-11 0-11h-11c-4 0-5-7-1-7h12"
        fill="none"
        :stroke="fillColor"
        stroke-dasharray="3.51496053, 3.51496053"
        stroke-dashoffset="4.218"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.7575"
        style="paint-order:normal"
      />
      <title>{{ title }}</title>
    </svg>
  </span>
</template>

<script>
export default {
  name: "NavigateTo",
  props: {
    title: {
      type: String,
      default: "NavigateTo"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>
<style scoped>
.icon__svg {
  height: 1em;
  width: 1em;
  position: absolute;
}

.v-icon.mdi.theme--light.text--text.add-leak {
  height: 1.25rem;
  font-size: 24px;
}
</style>
